import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";
import { StapelLogo } from "@/components/home/stapel-logo";
import { Button } from "@/components/ui/button";

export function NotFound() {
  return (
    <div className="min-h-screen bg-background px-4 sm:px-6">
      <div className="relative mx-auto flex min-h-screen max-w-7xl flex-col overflow-hidden border-x border-border bg-background">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute inset-x-0 top-0 h-80 bg-gradient-to-b from-secondary via-secondary/60 to-transparent" />
          <div className="absolute left-1/2 top-28 h-72 w-72 -translate-x-1/2 rounded-full bg-secondary/70 blur-3xl" />
        </div>

        <header className="relative z-10 flex items-center justify-between px-6 py-6 lg:px-10">
          <Link to="/" aria-label="Zur Startseite">
            <StapelLogo size={140} />
          </Link>

          <Button asChild variant="outline" size="sm">
            <Link to="/login">Login</Link>
          </Button>
        </header>

        <main className="relative z-10 flex flex-1 items-center justify-center px-6 pb-16 pt-6 lg:px-10">
          <section className="w-full max-w-3xl rounded-[2rem] border border-border bg-card/85 p-8 shadow-sm backdrop-blur sm:p-10">
            <div className="space-y-5">
              <div className="space-y-3">
                <h1 className="max-w-2xl text-4xl font-semibold leading-tight text-balance text-foreground sm:text-5xl">
                  Diese Seite ist nicht mehr verfügbar.
                </h1>
                <p className="max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
                  Der Link ist möglicherweise veraltet oder die Adresse wurde
                  falsch eingegeben.
                </p>
              </div>

              <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
                <Button asChild size="lg">
                  <Link to="/">
                    <ArrowLeft className="h-4 w-4" />
                    Zur Startseite
                  </Link>
                </Button>
                <Link
                  to="/login"
                  className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
                >
                  Oder direkt zum Login
                </Link>
              </div>
            </div>
          </section>
        </main>

        <footer className="relative z-10 border-t border-border px-6 py-4 text-sm text-muted-foreground lg:px-10">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p>&copy; 2026 stapel.ai. Alle Rechte vorbehalten.</p>
            <div className="flex items-center gap-4">
              <Link to="/impressum" className="hover:text-foreground">
                Impressum
              </Link>
              <Link to="/datenschutz" className="hover:text-foreground">
                Datenschutz
              </Link>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
